import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {HomeComponent} from './home.component';

import {LoginGuard} from 'guards/login.guard';

const routes: Routes = [
  {path: '', component: HomeComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
  providers: [],
})

export class HomeRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/home/home-routing.module.ts